import { render, staticRenderFns } from "./lkuBudgetproduksi_all.vue?vue&type=template&id=0fa44e06"
import script from "./lkuBudgetproduksi_all.vue?vue&type=script&lang=js"
export * from "./lkuBudgetproduksi_all.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports